import { Empty, Page, ui } from '../ui';

export function NotFound(): React.ReactElement {
  return (
    <Page>
      <header className={ui.stack ?? ''}>
        <h1 className="gb-headline">Nothing here</h1>
      </header>
      <Empty icon="compass">That page does not exist. The games are on the front page.</Empty>
    </Page>
  );
}
